/**
 * Sprint 40-hotfix · App-Version mit safe fallback.
 *
 * Die globalen `__APP_VERSION__` + `__BUILD_TIMESTAMP__` werden via
 * vite-define beim Build ersetzt. Wenn der Build fehlerhaft war (z.B.
 * docker-compose-build im Server-Container ohne korrekt gesetzte vite.config),
 * sind die Identifier zur Laufzeit `undefined` → ReferenceError → React-Crash
 * → White Screen.
 *
 * Hier safe-guard mit `typeof X === 'undefined'`-Check.
 */

export const APP_VERSION: string = (() => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '1.5';
  } catch {
    return '1.5';
  }
})();

export const BUILD_TIMESTAMP: string = (() => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return typeof __BUILD_TIMESTAMP__ !== 'undefined'
      ? __BUILD_TIMESTAMP__
      : new Date().toISOString();
  } catch {
    return new Date().toISOString();
  }
})();
